import React from 'react';
import 'twin.macro';
import { Navigate, useLocation, useOutletContext } from 'react-router-dom';
import useIsMobile from 'components/ResponsiveSwitcher/useIsMobile';
import { Sidebar } from 'containers/MesAnneesScolaires/Schoolyear/Sidebar';
import ButtonLink from 'components/Buttons/Link';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { routes } from 'containers/routes';
import { useTranslation } from 'react-i18next';
import TwoColumnsCardSidebar from 'components/TwoColumnsCardSidebar';
import { Schoolyear } from 'types/schoolyear';

export function RedirectToSchoolyearSettingsOrMobileMenu() {
  const { search } = useLocation();
  const { t } = useTranslation(['schoolyearSettings']);
  const { schoolyear } = useOutletContext<{
    schoolyear: Schoolyear;
  }>();

  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <TwoColumnsCardSidebar tw="pt-6">
        <div tw="mb-4">
          <ButtonLink
            tw="mb-4"
            minimal
            icon={ArrowLeftIcon}
            to={routes.schoolyearsSettings}
          >
            {t('schoolyearSettings:schoolYear_other')}
          </ButtonLink>
          <h1>
            {t('schoolyearSettings:yearX', { yearLabel: schoolyear?.label })}
          </h1>
        </div>
        <Sidebar />
      </TwoColumnsCardSidebar>
    );
  }

  return <Navigate to={{ pathname: 'general', search }} replace />;
}
